import { ReactNode } from 'react';
import { cx } from '@libs/classnames';
import styles from './LeadersList.module.css';
import { LandingChip } from '@features/landing/shared/ui/components/LandingChip';
import { pluralize } from '@libs/i18n';
import { LeaderboardPerson } from '@features/landing/grandprix/typings';

const POINTS_PLURAL = {
  zero: '0 баллов',
  one: '{number} балл',
  few: '{number} балла',
  many: '{number} баллов',
};

type Props = {
  leaders: LeaderboardPerson[];
  title?: ReactNode;
  className?: string;
  action?: ReactNode;
  preset?: 'landing' | 'club';
};

export function LeadersList({
  leaders,
  title,
  className,
  action,
  preset = 'landing',
}: Props) {
  return (
    <div className={cx(styles.root, styles[`preset_${preset}`], className)}>
      <h4 className={styles.title}>{title}</h4>
      {leaders.map((l, idx) => (
        <div key={idx} className={styles.item}>
          <div
            className={cx(styles.number, {
              [styles.prize]: l.number <= 3,
            })}
          >
            {l.number}
          </div>
          <div className={styles.firstName}>{l.firstName}</div>
          <div className={styles.lastName}>{l.lastName}</div>
          <div className={styles.score}>
            <LandingChip preset={preset}>
              {pluralize(POINTS_PLURAL, l.score)}
            </LandingChip>
          </div>
        </div>
      ))}
      {action && <div className={styles.action}>{action}</div>}
    </div>
  );
}
